import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const PanelBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusHalf};
  padding: ${spacing.eighth};
`;

export const PanelAction = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
  padding-bottom: ${spacing.eighth};

  button {
    &:focus:before {
      border: none;
    }
  }
`;
